export class AccessControlApiPaths {
    constructor(private readonly api: string) {}

    getUsers = (tenantId: string, serviceName: string, featureName: string, siteId: string) =>
        `${this.api}/${tenantId}/users?serviceName=${serviceName}&featureName=${featureName}&assetId=${siteId}`;
}
